import {STORE_CONTRACTOR_REQUEST, STORE_CONTRACTOR_SUCCESS, STORE_CONTRACTOR_FAILURE} from '../actions';
import {UPDATE_LANDLORD_CONTRACTOR_REQUEST, UPDATE_LANDLORD_CONTRACTOR_SUCCESS, UPDATE_LANDLORD_CONTRACTOR_FAILURE} from '../actions';

export const CONTRACTOR_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    business_name: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    post_code: '',
    contact_name: '',
    phone_number: '',
    email: '',
    gas_safe_number: ''
};

const contractorReducers = {
    [STORE_CONTRACTOR_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_CONTRACTOR_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [STORE_CONTRACTOR_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_LANDLORD_CONTRACTOR_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_LANDLORD_CONTRACTOR_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_LANDLORD_CONTRACTOR_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function contractor(state = CONTRACTOR_INITIAL_STATE, action) {
    let reducer = contractorReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/landlord-contractor.js